import React from "react";
import { Helmet } from "react-helmet";

export const DEFAULT_OG_IMAGE =
  "https://ezcarrentals.com.au/og-cover.jpg";

const HUNTINGDALE_LAT = -37.875783;
const HUNTINGDALE_LNG = 145.100611;

const SEO = ({
  title = "EZ Car Rentals | Car, Van & Ute Hire in Melbourne, Victoria, Australia",
  description = "Affordable car, van, and ute rental in Melbourne, Victoria, Australia. EZ Car Rentals offers reliable vehicle hire services in Huntingdale, Chadstone, and surrounding areas. Book online today!",
  keywords = "car rental Melbourne, van hire Victoria, ute rental Australia, car hire Melbourne, vehicle rental Victoria, cheap car rental Melbourne, van hire Chadstone, ute hire Huntingdale, car rental Australia, EZ Car Rentals",
  image = DEFAULT_OG_IMAGE,
  url = "https://ezcarrentals.com.au",
  type = "website",
  locale = "en_AU",
  siteName = "EZ Car Rentals",
  robots = "index, follow",
  structuredData = null,
}) => {
  const fullTitle = title.includes("EZ Car Rentals")
    ? title
    : `${title} | EZ Car Rentals`;
  const fullUrl = url.startsWith("http")
    ? url
    : `https://ezcarrentals.com.au${url}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="EZ Car Rentals" />
      <meta name="robots" content={robots} />
      <meta name="language" content="English" />

      <meta name="geo.region" content="AU-VIC" />
      <meta name="geo.placename" content="Huntingdale, Melbourne" />
      <meta
        name="geo.position"
        content={`${HUNTINGDALE_LAT};${HUNTINGDALE_LNG}`}
      />
      <meta name="ICBM" content={`${HUNTINGDALE_LAT}, ${HUNTINGDALE_LNG}`} />

      <meta name="locality" content="Huntingdale" />
      <meta name="region" content="Victoria" />
      <meta name="postal-code" content="3166" />
      <meta name="country-name" content="Australia" />

      <link rel="canonical" href={fullUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:secure_url" content={image} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={fullTitle} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content={locale} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      <meta name="apple-mobile-web-app-title" content="EZ Car Rentals" />
      <meta name="application-name" content="EZ Car Rentals" />
      <meta name="theme-color" content="#000000" />

      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
